// extracted by mini-css-extract-plugin
export default {"root":"WLtkqo","alert":"judqhg","icon":"ZxXGXh","title":"V8hVk9","description":"qGMc2n","info":"Pd7VU1","infoIcon":"BzXql7"};